export const mockServices = [
  {
    name: 'Website Development',
    benefit: 'Professional online presence that works 24/7'
  },
  {
    name: 'Landing Pages',
    benefit: 'Convert visitors into customers automatically'
  },
  {
    name: 'Lead Systems',
    benefit: 'Generate quality leads while you focus on business'
  },
  {
    name: 'WhatsApp Automation',
    benefit: 'Handle customer queries without manual effort'
  },
  {
    name: 'Digital Setup',
    benefit: 'Complete digital infrastructure for small businesses'
  }
];

export const mockProblems = [
  {
    icon: 'Clock',
    text: 'Business depends fully on owner'
  },
  {
    icon: 'RefreshCw',
    text: 'No systems or automation'
  },
  {
    icon: 'AlertCircle',
    text: 'No time freedom'
  },
 
];

export const mockSolutions = [
  {
    title: 'Professional Websites',
    description: 'Modern, responsive websites that represent your brand and work around the clock'
  },
  {
    title: 'Landing Pages That Convert',
    description: 'Conversion-optimized pages designed to turn visitors into paying customers'
  },
  {
    title: 'Lead Generation Systems',
    description: 'Automated systems that capture and nurture leads without constant manual work'
  },
  {
    title: 'WhatsApp Automation',
    description: 'Smart automation for customer communication that saves hours every day'
  },
  {
    title: 'Scalable Digital Systems',
    description: 'Build once, benefit forever — systems designed for long-term growth'
  }
];

export const mockWhyPoints = [
  {
    title: 'System-Driven Approach',
    description: 'We don\'t just design — we build systems that run your business efficiently'
  },
  {
    title: 'Beginner-Friendly',
    description: 'Perfect for first-time digital clients. We guide you through every step'
  },
  {
    title: 'Business-Focused',
    description: 'Every solution is designed to save you time and increase revenue'
  },
  {
    title: 'Long-Term Scalable',
    description: 'Solutions that grow with your business, not just quick fixes'
  }
];